import * as configureSolarApi from '../store/configureSolarApi';

const evubillReducer = (state = {
    EvubillUI: [],
    ...configureSolarApi.initialState
}, action) => {
    switch (action.type) {
        case "RECEIVE_EvuBillClass_evubillReducer":
            return { ...state, EvubillUI: action.value, isLoaded: true };
    }

    return configureSolarApi.switchCaseForDefaultActionTypesForReducers(action, state);
};
export default evubillReducer;
